export type PinPolicyLanguage = "ar" | "en";

export function validateNewPin(pin: string, language: PinPolicyLanguage): string {
  const value = pin.trim();
  const ar = language === "ar";
  if (!/^\d{4,8}$/.test(value)) {
    return ar ? "يجب أن يتكوّن رمز PIN من 4 إلى 8 أرقام فقط." : "PIN must contain 4 to 8 digits only.";
  }
  const repeated = new Set(value).size === 1;
  const sequential = "0123456789".includes(value) || "9876543210".includes(value);
  if (repeated || sequential) {
    return ar ? "لا يمكن استخدام PIN بأرقام متكررة أو متسلسلة. اختر أرقامًا غير متتابعة." : "Sequential or repeated-digit PINs are not allowed. Choose a non-sequential PIN.";
  }
  return "";
}
